<template>
    <div>
        <div class='basket-item'>
            <DynamicImageContainer class="product-image" :image='item.product.main_picture'/>
            <div class='text-container'>
                <div class='item-heading-container'>
                    <div class='item-text'>{{item.product.productname}}</div>
                    <div class='delete-icon' @click='removeItemFromCart'><i class="fa-light fa-trash-can"></i></div>
                </div>
                <div v-if='(typeof item.product.selected_variant !== "undefined")'><span class='variant-name-title'>{{item.product.selected_variant.name}}:</span> {{item.product.selected_variant.value}}</div>
                <div>Quantity: {{item.quantity}}</div>
                <div>Total: £{{item.total}}</div>
            </div>
        </div>
        <div class='total'>
        </div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import {checkAuth, fireOmetriaBasketEvent} from "@/global/modules/functions.js";

export default {
    components: {DynamicImageContainer},
    emits: ['updatedCartListener'],
    props: {
        item:{
            default:{
                product: {}
            }
        }
    },
    methods:{
        async removeItemFromCart(){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.item.product,
                   type: 'remove_item_from_cart'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.$emit('updatedCartListener', this.item.product, 'removed');
                fireOmetriaBasketEvent(results.cart, results.basket_id);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.basket-item{
    display: flex;
    gap: 20px;
}

.product-image{
    width: 30px;
    object-fit: cover;
    object-position: 50% 0;
}

.text-container{
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 0.88rem;
    flex-grow: 1;
}

.item-text{
    font-weight: 500;
}

.variant-name-title{
    text-transform: capitalize;
}

.delete-icon{
    font-size: 1.1rem;
    cursor: pointer;
    color: var(--primary-colour-1);
}

.item-heading-container{
    display: flex;
    justify-content: space-between;
}

</style>